module.exports = __webpack_public_path__ + "static/img/kefuCode.50c02db.png";


//////////////////
// WEBPACK FOOTER
// ./static/kefuCode.png
// module id = d405
// module chunks = 1